import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import UserNotRegisteredError from '@/components/UserNotRegisteredError';

const DefaultFallback = () => (
  <div className="fixed inset-0 flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin"></div>
  </div>
);

export default function ProtectedRoute({ fallback = <DefaultFallback />, unauthenticatedElement, requireAdmin = false }) {
  const { user, isAuthenticated, isLoadingAuth, authChecked, authError, checkUserAuth } = useAuth();

  useEffect(() => {
    if (!authChecked && !isLoadingAuth) {
      checkUserAuth();
    }
  }, [authChecked, isLoadingAuth, checkUserAuth]);

  if (isLoadingAuth || !authChecked) {
    return fallback;
  }

  if (authError) {
    if (authError.type === 'user_not_registered') {
      return <UserNotRegisteredError />;
    }
    return unauthenticatedElement;
  }

  if (!isAuthenticated) {
    return unauthenticatedElement;
  }

  // A signed-in customer must never be able to browse the admin dashboard.
  if (requireAdmin && user?.role !== 'admin') {
    return <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-4 text-center"><h1 className="text-2xl font-semibold">Aðgangur óheimill</h1><p>Þetta svæði er aðeins fyrir stjórnendur Vintage Treyja.</p><a className="underline" href="/reikningur">Fara á minn reikning</a></div>;
  }

  return <Outlet />;
}
